export default "/images/be048e220edd8e683d4a52ed08cbe3e9.avif";